// extracted by mini-css-extract-plugin
export var label = "_l7-2";
export var slideContainer = "_l7-0";
export var slider = "_l7-1";